(function () {
  function initGalleryHeightSync(gallery) {
    const main = gallery.querySelector('.main-image');
    const thumbs = gallery.querySelector('.thumbnails');
    if (!main || !thumbs) return;

    // Try to measure the most “stable” visible box:
    // 1) active slide, 2) fallback to main-image itself
    function getMainHeight() {
      const activeSlide =
        main.querySelector('.slider__item.is-active') ||
        main.querySelector('.slider__item[aria-hidden="false"]');

      const target = activeSlide || main;

      // Use getBoundingClientRect for sub-pixel accuracy
      const h = Math.round(target.getBoundingClientRect().height);

      // Guard: don’t write nonsense values
      return h > 0 ? h : null;
    }

    function applyHeight() {
      const h = getMainHeight();
      if (!h) return;
      gallery.style.setProperty('--main-media-h', h + 'px');
    }

    // Apply immediately, then again after images finish loading
    applyHeight();

    // Re-apply when any image in main finishes loading
    main.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', applyHeight, { once: false });
    });

    // Observe size changes (slide changes often change height)
    const ro = new ResizeObserver(() => applyHeight());
    ro.observe(main);

    // If your carousel swaps active slide without resizing main container,
    // observing the active slide helps too.
    const active = main.querySelector('.slider__item.is-active');
    if (active) ro.observe(active);

    // Also respond to viewport changes
    window.addEventListener('resize', applyHeight);

    // Respond to thumbnail clicks (slide change)
    thumbs.addEventListener('click', () => {
      // Let the DOM update active class first
      requestAnimationFrame(() => requestAnimationFrame(applyHeight));
    });

    // If your theme dispatches custom events, you can optionally hook them here.
    // gallery.addEventListener('slidechange', applyHeight);
  }

  function boot() {
    document.querySelectorAll('media-gallery.product-column-left').forEach(initGalleryHeightSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify section re-render (theme editor / variant updates sometimes)
  document.addEventListener('shopify:section:load', boot);
})();